module.exports = __webpack_public_path__ + "static/polytank-0bd2f17a49ea95ea2a70a8f35b2c30ca.svg";